export default function trackEvent(eventName, details = {}) {
	if (typeof(window) !== 'undefined' && window.analytics) {
		window.analytics.track(eventName, details)
	}
}